export default "__VITE_ASSET__C6OLLQpf__"